import gql from 'graphql-tag'

export const addSaveOrderForLaterQuery = gql`
  query ($cartId: String!, $customer_order_number: String) {
    addSaveOrderForLater(cart_id: $cartId , customer_order_number: $customer_order_number) {
      message
    }
  }
`
